import { parseRFC5646Tag } from './locale';

/**
 * Tries to parse testing tools from the current user agent.
 *
 * @returns {boolean}
 */
export function isTestingTool() {
  const testingTools = ['Chrome-Lighthouse'];
  let response = false;

  testingTools.forEach((tool) => {
    if (navigator.userAgent.indexOf(tool) !== -1) {
      response = true;
    }
  });
  return response;
}

export function browserLanguage() {
  return parseRFC5646Tag(navigator.language);
}



// WEBPACK FOOTER //
// ./src/util/browser.js